module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_5-c93366c8cdb1ac5ff5b2077a73efd252.svg";